<i18n>
{
  "ja": {
    "number-of-items-to-display": "表示する件数:",
    "display-item": "{totalCount} 件中 {firstItem}～{lastItem} 件を表示"
  }
}
</i18n>

<template>
  <section class="pagination flex items-center lg:justify-end my-6 h-6 flex-wrap text-sm md:text-base">
    <div>
      <span class="mr-0 md:mr-2">{{ $t('number-of-items-to-display') }}</span>
      <select class="page-size input-select mr-8 md:mr-10" :value="perPage" @change="onChangePerPage">
        <option :value="10">10</option>
        <option :value="30">30</option>
        <option :value="50">50</option>
        <option :value="100">100</option>
      </select>
    </div>
    <span class="page-display-items flex-grow md:flex-none mr-0 text-right md:mr-10 md:text-left">{{ $t('display-item', {
      totalCount,
      firstItem: (this.currentPage - 1) * perPage + 1,
      lastItem: (this.currentPage === this.lastPage) ? totalCount : this.currentPage * perPage })
    }}</span>
    <div class="page-navs flex flex-grow md:flex-none justify-end md:justify-start">
      <button class="material-icons" @click="navigate(1)" :disabled="currentPage === 1">first_page</button>
      <button class="material-icons" @click="navigate(currentPage - 1)" :disabled="currentPage === 1">navigate_before</button>
      <button class="material-icons" @click="navigate(currentPage + 1)" :disabled="totalCount === 0 || currentPage === lastPage">navigate_next</button>
      <button class="material-icons" @click="navigate(lastPage)" :disabled="totalCount === 0 || currentPage === lastPage">last_page</button>
    </div>
  </section>
</template>

<style lang="sass" scoped>
.pagination > select
  height: 24px

button.material-icons
  @apply mr-2 cursor-auto
  &:hover
    @apply cursor-pointer
  &:disabled
    @apply text-gray-300
    &:hover
      @apply cursor-auto
</style>

<script>
export default {
  props: {
    currentPage: { type: Number, required: true },
    totalCount: { type: Number, required: true },
    lastPage: { type: Number, required: true },
    perPage: { type: Number, default: 10 }
  },
  methods: {
    navigate (page) {
      this.$emit('page-change', page);
    },
    onChangePerPage (event) {
      const newValue = parseInt(event.target.value);
      this.$emit('page-size-change', newValue);
    }
  }
}
</script>